// extracted by mini-css-extract-plugin
export var arrow = "our-approach-key-figure-row-module--arrow--8a22e";
export var carouselButton = "our-approach-key-figure-row-module--carouselButton--c5790";
export var carouselButtons = "our-approach-key-figure-row-module--carouselButtons--8cdb6";
export var container = "our-approach-key-figure-row-module--container--e8539";
export var keyFigure = "our-approach-key-figure-row-module--keyFigure--c6f08";
export var keyFiguresRow = "our-approach-key-figure-row-module--keyFiguresRow--6869f";
export var mobileCarousel = "our-approach-key-figure-row-module--mobileCarousel--fdace";
export var nextButton = "our-approach-key-figure-row-module--nextButton--6d047";
export var prevButton = "our-approach-key-figure-row-module--prevButton--ffda7";
export var title = "our-approach-key-figure-row-module--title--46649";